import { render, staticRenderFns } from "./CreateModal.vue?vue&type=template&id=cf6ae228&scoped=true&"
import script from "./CreateModal.vue?vue&type=script&lang=js&"
export * from "./CreateModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateModal.vue?vue&type=style&index=0&id=cf6ae228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf6ae228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf6ae228')) {
      api.createRecord('cf6ae228', component.options)
    } else {
      api.reload('cf6ae228', component.options)
    }
    module.hot.accept("./CreateModal.vue?vue&type=template&id=cf6ae228&scoped=true&", function () {
      api.rerender('cf6ae228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/CreateModal.vue"
export default component.exports